<template>
  <div class="hello">
   
        <div v-for="(item, index) in text" :key="index" :style="color">
          <div class="bottom">
            {{ item }}
          </div>
        </div>

  </div>
</template>

<script>
export default {
  name: "Bottom",
  data() {
    return {
      
    };
  },
  props: {
 
  
    text: Array,
    color:String


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.bottom {
  font-size: 10px;
 
  line-height: 14px;
  text-align: center
}
</style>
